export enum ContractBillingTypeEnum {
  FlatRate = "flat_rate",
  Monthly = "monthly"
}
